// extracted by mini-css-extract-plugin
export default {"tooltip":"CU-z","arrow":"DU-z"};